import React, {useEffect, useState} from "react";
import {AnimatePresence, motion} from "framer-motion";
import { workTags } from "../../globals/data";
import { countProjects, cursorChange } from "../../globals/helpers";
import './bottomfilter.css'


const BottomFilter = ({activeFilter, setActiveFilter, projData}) => {
    const [filterInfo, setFilterInfo] = useState(null);

    useEffect(() => {
        let [tmpFilterInfo, totalItems] = countProjects(projData, workTags);
        tmpFilterInfo['0'] = {
            name: "ALL",
            count: totalItems
        };
        setFilterInfo(tmpFilterInfo);
    }, [])

    function handleFilterSelection(idx){
        setActiveFilter(idx)
    }

    const filterWrapperVariants = {
        initial:{ transition: {
            staggerChildren: 0.05
        }},
        animate:{},
        exit:{
            transition: {
                staggerChildren: 0.05
            }
        }
    }

    const filterItemVariants = {
        initial: {
            transform: 'translate3d(0, 100%, 0)'
        }, animate: (i) => ({
            transform: 'translate3d(0, 0%, 0)',
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1],
                delay: 0.55+ i*0.05
            }
        }), exit: {
            transform: 'translate3d(0, 100%, 0)',
            transition: {
                duration: 1,
                ease: [0.87, 0, 0.13, 1]
            }
        }
    }

    return(
        <motion.div 
            className="bottom_filter_wrapper"
            initial="initial"    
            animate="animate"    
            exit="exit"
            variants={filterWrapperVariants}
        >
            {
                filterInfo &&
                Object.entries(filterInfo).map(([k, value], idx) => (
                    <motion.div 
                        className={`bottom_fi_wrap ${k == activeFilter ? 'b_act_filter' : ''}`} 
                        onMouseEnter={(e) => {
                            e.target.classList.add('hov');
                            cursorChange(true, 1)
                        }}
                        onMouseLeave={(e) => {
                            e.target.classList.remove('hov');
                            cursorChange(false)
                        }}
                        onClick={() => {handleFilterSelection(Number(k))}}
                        variants={filterItemVariants}
                        custom={idx}
                    >
                        <span className="b_filter-bullet"></span>
                        <div className={`b_filter_item`}>
                            <span className="b_filter_name">{value.name.replace('_', ' ').toLocaleLowerCase()}</span>
                            <div className="b_filter_count_wrap">
                                <span>[</span>
                                <span>{value.count}</span>
                                <span>]</span>
                            </div>
                        </div>
                    </motion.div>
                ))
            }
        </motion.div>
    )
}

export default BottomFilter